import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

/* Layout */
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
          path: '/home',
          name: 'home',
          component: HomeView
      },
      {
        path: '/download',
        name: 'download',
        component: () => import('../views/DownloadView.vue')
      },
      {
        path: '/popular',
        name: 'popular',
        component: () => import('../views/PopularList.vue')
      },
      {
        path: '/video',
        name: 'video',
        component: () => import('../views/Video.vue')
      },
    ]
  },
  {
    path: '/user_agreenment',
    name: 'UserAgreenment',
    component: () => import('../views/UserAgreenmentView.vue')
  },
  {
    path: '/privacy_policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicyView.vue')
  },
  {
    path: '/sub_description',
    name: 'SubDescription',
    component: () => import('../views/SubDescription.vue')
  },
  {
    path: '/qa',
    name: 'QA',
    component: () => import('../views/QAView.vue')
  },
  {
    path: '/facebook-data-deletion-instructions-url',
    name: 'Facebook',
    component: () => import('../views/FacebookView.vue')
  },
  {
    path: '/app-guide',
    name: 'Appguide',
    component: () => import('../views/Appguide.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
